/* OPQ About — cobe globe (https://github.com/shuding/cobe).
   Loaded as ES module from esm.sh so we don't add a build step. The globe
   sits in the left column when no portrait image is set, with Taipei as
   the anchored marker and a few destination cities for visual context. */

import createGlobe from 'https://esm.sh/cobe@0.6.3';

const CITY_MARKERS = [
  { location: [25.0330, 121.5654], size: 0.10 }, // Taipei (HQ)
  { location: [40.7128, -74.0060], size: 0.05 }, // New York
  { location: [51.5074,  -0.1278], size: 0.05 }, // London
  { location: [35.6762, 139.6503], size: 0.05 }, // Tokyo
  { location: [37.5665, 126.9780], size: 0.05 }, // Seoul
  { location: [48.8566,   2.3522], size: 0.05 }, // Paris
  { location: [52.5200,  13.4050], size: 0.05 }, // Berlin
  { location: [-33.8688,151.2093], size: 0.05 }, // Sydney
  { location: [22.3193, 114.1694], size: 0.05 }, // Hong Kong
];

function initOpqGlobe(root) {
  const canvas = root.querySelector('[data-opq-globe-canvas]');
  if (!canvas) return;

  const dpr = Math.min(window.devicePixelRatio || 1, 2);
  let width = 0;
  let height = 0;
  let phi = 4.4;     // initial rotation: roughly Taiwan-facing
  let pointerDown = false;
  let pointerStartX = 0;
  let phiOffset = 0;

  const measure = () => {
    const rect = canvas.getBoundingClientRect();
    width  = rect.width;
    height = rect.height;
  };

  measure();
  const ro = new ResizeObserver(measure);
  ro.observe(canvas);

  const globe = createGlobe(canvas, {
    devicePixelRatio: dpr,
    width:  width  * dpr,
    height: height * dpr,
    phi: 0,
    theta: 0.32,
    dark: 0,
    diffuse: 1.15,
    mapSamples: 16000,
    mapBrightness: 5.5,
    baseColor:   [1, 1, 1],
    markerColor: [0.95, 0.18, 0.30],
    glowColor:   [1, 1, 1],
    markers: CITY_MARKERS,
    onRender: (state) => {
      if (!pointerDown) phi += 0.0028;
      state.phi = phi + phiOffset;
      state.width  = width  * dpr;
      state.height = height * dpr;
    },
  });

  /* Click-and-drag to spin manually; release to resume auto-rotation. */
  canvas.addEventListener('pointerdown', (e) => {
    pointerDown = true;
    pointerStartX = e.clientX - phiOffset / 0.005;
    canvas.style.cursor = 'grabbing';
  });
  const stopDrag = () => {
    pointerDown = false;
    phi += phiOffset;
    phiOffset = 0;
    canvas.style.cursor = 'grab';
  };
  window.addEventListener('pointerup', stopDrag);
  window.addEventListener('pointerleave', stopDrag);
  canvas.addEventListener('pointermove', (e) => {
    if (!pointerDown) return;
    phiOffset = (e.clientX - pointerStartX) * 0.005;
  });
}

document.querySelectorAll('[data-opq-globe]').forEach(initOpqGlobe);
